// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".user-default-image{width:30px}.sign-hover:hover{transition:0.4s transform ease-in-out;transform:scale(1.2)}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/users/userTable.scss"],"names":[],"mappings":"AAAA,oBACE,UACF,CAAC,kBAGC,qCAAsC,CACtC,oBAAqB","file":"userTable.scss","sourcesContent":[".user-default-image {\n  width: 30px\n}\n\n.sign-hover:hover {\n  transition: 0.4s transform ease-in-out;\n  transform: scale(1.2);\n}"]}]);
// Exports
module.exports = exports;
